export class NotFoundException extends Error implements Error {
  name = 'NotFoundException';
  stack?: string;
  cause?: Error;
  message: string;

  constructor(message: string = 'Not found') {
    super(message);
  }
}
